import React, {useState} from "react";
import styles from "./Business.module.css";
import {Route, Link, useNavigate} from "react-router-dom";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import DealPills from "../DealPills/DealPills";
import {PiMapPinAreaBold} from "react-icons/pi";
import StarRating from "../StarRating/StarRating";

const Business = ({ business }) => {
    const navigate = useNavigate();

    const distance = business.distance_mi ? parseFloat(business?.distance_mi):parseFloat(business?.distance);
    const hasDeals = business?.hasDeals;
    const hasProducts = business?.hasProducts;


    const handleClick = (e, business, type) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('type', type);
        if (type) {
            navigate(`/business/${business.id}?menuType=${type}`);
        } else {
            navigate(`/business/${business.id}`);
        }
    }

    return (
        <Link to={`/business/${business.id}`} className={styles.BusinessLink}>
            <div className={styles.Business}>
                <div className={`flex flex-col justify-between`}>
                    <div className={styles.imageContainer} style={{ backgroundImage: `url(${business?.avatar_image?.small_url || business?.logoImage})` }}>

                        <img src={business?.avatar_image?.small_url || business?.logoImage}
                             style={{ display: (business.logoImage && business?.logoImage.includes('(')) ? 'block' : 'none' }}
                             alt={business?.name}/>
                    </div>
                    <div className={`text-sm text-center w-full mt-1`}>
                        {distance ? distance.toFixed(1) : 'N/A'} mi.
                    </div>
                </div>

                <div className={styles.infoColumn}>
                    <h2 className={styles.businessLink}>

                        {business.name}
                        {/*} <div className={styles.engagement}>
                            <MdOutlineRemoveRedEye/>
                            {business.engagement}
                        </div> */}
                    </h2>
                    <div className={styles.cityState}>{business.city}, {business.state}</div>
                    <div className={styles.ratingWrap}>
                        <StarRating rating={business.rating || business.starRating || 5} maxRating={5} size={15}/>
                        <h3 className={styles.rating}>{`${business.rating || business.starRating || 5}/5`}</h3>

                    </div>
                    <div className={styles.BusinessInformation}>
                        {/*business.deals && (<DealPills deals={business?.deals?.splice(0,6)}/>) */}
                        <div className="flex items-center gap-1 my-1 justify-start mx-[auto]" style={{ width: "calc(100% + 24px)" }}>
                            {business.hasDeals && (
                                <a onClick={(e) => {
                                    handleClick(e, business, 'deals');
                                }} className={`text-center px-3 py-0.5 text-xs rounded-xs bg-brand-green text-white dark:border-brand-green border-brand-green border-solid text-white box-border !text-black`}>
                                    Deals
                                </a>
                            )}
                            {!business.hasDeals && (
                                <a onClick={(e) => {
                                    handleClick(e, business, 'menu');
                                }} className={`text-center px-3 py-0.5 text-xs rounded-xs bg-brand-purple border-1 dark:border-brand-purple border-brand-purple border-solid text-white box-border`}>
                                    Menu
                                </a>
                            )}


                        </div>
                    </div>
                </div>

            </div>
        </Link>

    );
};

export default Business;
